export const getFinancialYears = () => {
  let fiscalYears: string[] = [];
  for (let i = 0; i < 1; i++) {
    const year = new Date().getFullYear() + i + 1;
    const fiscalYear = `${year}-${year + 1}`;
    fiscalYears.unshift(fiscalYear);
  }
  for (let i = 0; i < 25; i++) {
    const year = new Date().getFullYear() - i;
    const fiscalYear = `${year}-${year + 1}`;
    fiscalYears.push(fiscalYear);
  }
  return fiscalYears;
};

export const getGstrFinancialYears = () => {
  let fiscalYears: string[] = [];
  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 2017; year--) {
    const fiscalYear = `${year}-${year + 1}`;
    fiscalYears.push(fiscalYear);
  }

  return fiscalYears;
};

export const getAutFinancialYears = () => {
  let fiscalYears: string[] = [];
  for (let i = 0; i < 1; i++) {
    const year = new Date().getFullYear() + i + 1;
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.unshift(fiscalYear);
  }
  for (let i = 0; i < 25; i++) {
    const year = new Date().getFullYear() - i;
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.push(fiscalYear);
  }
  return fiscalYears;
};

export const getServiceFinancialYears = () => {
  let fiscalYears: string[] = [];
  for (let i = 0; i < 1; i++) {
    const year = new Date().getFullYear() + i + 1;
    const fiscalYear = `${year}-${year + 1}`;
    fiscalYears.unshift(fiscalYear);
  }
  for (let i = 0; i < 5; i++) {
    const year = new Date().getFullYear() - i;
    const fiscalYear = `${year}-${year + 1}`;
    fiscalYears.push(fiscalYear);
  }
  return fiscalYears;
};

export const getUdinAutFinancialYears = () => {
  let fiscalYears: string[] = [];

  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 2021; year--) {
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.push(fiscalYear);
  }

  return fiscalYears;
};

export const getFormsFinancialYears = () => {
  let fiscalYears: string[] = [];

  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 2010; year--) {
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.push(fiscalYear);
  }

  return fiscalYears;
};

export const getFYYears = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth(); // 0 = Jan, 11 = Dec

  // Assuming financial year starts in April
  const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
  const currentFinancialYear = `${startYear}-${startYear + 1}`;

  const fiscalYears: string[] = [currentFinancialYear];

  // Add previous years
  for (let i = 1; i <= 5; i++) {
    const year = startYear - i;
    fiscalYears.push(`${year}-${year + 1}`);
  }

  return fiscalYears;
};
